module.exports = __webpack_public_path__ + "assets/img/23_35.1cffd6ba.jpg";